export const discordRoles = [
  'recruiter',
  'sponsor',
  'judge',
  'panelist',
  'workshop_host',
  'mentor',
  'volunteer',
  'mlh',
];

export const applicationQuestionData = [
  {
    name: 'oneSentenceEssay',
    question:
      'You are given an elephant. You cannot sell or give away the elephant. What do you do with the elephant?',
    category: 'oneSentenceEssay',
  },
  {
    name: 'shortEssay',
    question:
      'If you could not do anything related to school, work, or coding for 4 months, what would you do and why?',
    category: 'shortEssay',
  },
  {
    name: 'longEssay',
    question:
      'Tell us about a project you’ve enjoyed working on (this can be non-technical!). What made you decide to work on this project? What challenges did you face and how did you overcome them?',
    category: 'longEssay',
  },
  {
    name: 'requestedWorkshops',
    question: 'Requested workshops.',
    category: null,
  },
];

// max scores for each category
export const maxScores = {
  longEssay: 6,
  shortEssay: 4,
  oneSentenceEssay: 3,
  portfolio: 6,
};

export const checkInActionMap = {
  MUST_SIGN_WAIVER:
    "The participant's parent/guardian must have signed the minor waiver.",
  MUST_ISSUE_MINOR_WRISTBAND:
    'The participant must be given a minor wristband as they cannot leave without a parent/guardian/authorized adult.',
  MUST_SEE_ADMIN:
    'Participant has been flagged. Please contact an admin for futher processing.',
};

export const applicationQuestions = applicationQuestionData.reduce(
  (a, k) => ({ ...a, [k['name']]: k['question'] }),
  {},
);
